"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("../stores/global");
function toggleAutoStart(state) {
    var action = function (dispatch) {
        dispatch((0, global_1.setAutoStart)(state));
    };
    action.type = "toggleAutoStart";
    return action;
}
exports.default = toggleAutoStart;
//# sourceMappingURL=toggleAutoStart.js.map